import { render, staticRenderFns } from "./ServiceGroups.vue?vue&type=template&id=f4bb429a&scoped=true"
import script from "./ServiceGroups.vue?vue&type=script&lang=js"
export * from "./ServiceGroups.vue?vue&type=script&lang=js"
import style0 from "./ServiceGroups.vue?vue&type=style&index=0&id=f4bb429a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4bb429a",
  null
  
)

export default component.exports